import { ListParams } from '../../../slices/utils';
import { Ifilter } from '../filters/interfaces';
import { ActiveInactiveFilterState } from '../activeInactiveToggle';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

const isPlgExternalEnv = isFeatureEnabled(Features.PlgExternal);

export const setStatusField = (request: ListParams<Ifilter[]>, value: ActiveInactiveFilterState): void => {
  if (isPlgExternalEnv) {
    request.status = value;
  } else {
    request.active = value;
  }
};

export const setActiveField = (request: ListParams<Ifilter[]>, value: ActiveInactiveFilterState): void => {
  request.active = value;
};